// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-module__app--UPalD {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    min-height: 500px;
    width: 500px;
    background: #151b23;
    padding: 20px;
    gap: 20px;

    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;IAEvB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,SAAS;;IAET,YAAY;AAChB","sourcesContent":[".app {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    min-height: 500px;\n    width: 500px;\n    background: #151b23;\n    padding: 20px;\n    gap: 20px;\n\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `App-module__app--UPalD`
};
export default ___CSS_LOADER_EXPORT___;
